module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="livechat_message_popup_wrapper" style="display: none;">\r\n    <div class="card" role="region" aria-labelledby="card-title" aria-describedby="card-desc">\r\n        <div class="card-content">\r\n            <p id="card-desc">\r\n                ' +
((__t = ( description )) == null ? '' : __t) +
'\r\n            </p>\r\n        </div>\r\n\r\n        <div class="card-actions" role="group" aria-label="Card actions">\r\n            <button class="btn btn-close" id="livechat_message_popup_close" aria-label="Close Message Popup"\r\n                title="Close">\r\n                ' +
((__t = ( closeButtonText )) == null ? '' : __t) +
'\r\n            </button>\r\n\r\n            <button class="btn btn-primary" id="livechat_message_popup_start_chat" aria-label="Start Chat"\r\n                title="Start Chat">\r\n                ' +
((__t = ( submitButtonText )) == null ? '' : __t) +
'\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>';

}
return __p
}